/**
 * @fileoverview
 */
import fetch from "@lib/fetch";

import { userInfoCacheKey } from "../../appsUserInfo";
import { reactQueryMutationAdapter } from "../../reactQueryFetcherAdapters";
import { testUserNamesCacheKey } from "./constants";
import { appSettingsInternalUserGroupsDeleteTestUserCacheKeys } from "./constants";
import type { DeleteTestUserBody, DeleteTestUserResult } from "./types";

export const deleteTestUser = reactQueryMutationAdapter(
  [userInfoCacheKey, testUserNamesCacheKey, ...appSettingsInternalUserGroupsDeleteTestUserCacheKeys],
  (body: DeleteTestUserBody): Promise<DeleteTestUserResult> => {
    return fetch("/internal_user_groups/delete_test_user", "POST", body);
  }
);
